import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { PagesRoutes } from './pages.routing';
import { CoreModule } from '../core/core.module';
import { DetailPayModule } from './detail-pay/detail-pay.module';
import { AccountYacareModule } from './account-yacare/account-yacare.module';
import { UserQrModule } from './user-qr/user-qr.module';
import { SharedModule } from '../shared/shared.module';
import { CashOutModule } from './cash-out/cash-out.module';
import { ToolbarModule } from './public/toolbar/toolbar.module';
import { TableMovementsModule } from './table-movements/table-movements.module';
import { NewCommerceModule } from './new-commerce/new-commerce.module';
import { CollectOptionsModule } from './collect-options/collect-options.module';
import { WithdrawCashModule } from './withdraw-cash/withdraw-cash.module';
import { HelpViewModule } from './help-view/help-view.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { PayOrderModule } from './pay-order/pay-order.module';
import { MessageWarnModule } from './public/message-warn/message-warn.module';
import { FrequentQuestionsModule } from './frequent-questions/frequent-questions.module';
import { TermsAndConditionsModule } from './terms-and-conditions/terms-and-conditions.module';
import { FooterModule } from './public/footer/footer.module';
import { MyCommerceModule } from './my-commerce/my-commerce.module';
import { LoginModule } from './public/login/login.module';
import { NewFooterModule } from './public/new-footer/new-footer.module';
import { PrivacyPolicyModule } from './privacy-policy/privacy-policy.module';

@NgModule({
  imports: [
    CoreModule,
    SharedModule,
    RouterModule.forChild(PagesRoutes),
    CommonModule,
    TranslateModule.forChild({
      isolate: false
    }),
    LoginModule,
    DetailPayModule,
    CashOutModule,
    UserQrModule,
    AccountYacareModule,
    ToolbarModule,
    TableMovementsModule,
    MyCommerceModule,
    NewCommerceModule,
    CollectOptionsModule,
    WithdrawCashModule,
    HelpViewModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    PayOrderModule,
    MessageWarnModule,
    FrequentQuestionsModule,
    TermsAndConditionsModule,
    FooterModule,
    NewFooterModule,
    PrivacyPolicyModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PagesModule {}
